var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49603 3.49597C3.71299 3.27901 4.06475 3.27901 4.28171 3.49597L9.99998 9.21424L15.7183 3.49597C15.9352 3.27901 16.287 3.27901 16.5039 3.49597C16.7209 3.71293 16.7209 4.06469 16.5039 4.28165L10.7857 9.99992L16.5039 15.7182C16.7209 15.9352 16.7209 16.2869 16.5039 16.5039C16.287 16.7208 15.9352 16.7208 15.7183 16.5039L9.99998 10.7856L4.28171 16.5039C4.06475 16.7208 3.71299 16.7208 3.49603 16.5039C3.27907 16.2869 3.27907 15.9352 3.49603 15.7182L9.2143 9.99992L3.49603 4.28164C3.27907 4.06469 3.27907 3.71293 3.49603 3.49597Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteClose);
export default __webpack_public_path__ + "static/media/white-close.364b9942e24ed0d651431c156dc13136.svg";
export { ForwardRef as ReactComponent };